import { type ReactNode } from 'react';
import { useConfiguracaoPublica } from '../lib/hooks';
import { dataLonga, valorConfig } from '../lib/formato';
import { PortalShell } from '../componentes/PortalShell';
import { Esqueleto, FalhaRede } from '../componentes/ui';
import { ApiError } from '../../lib/http';

/**
 * Termos da campanha (UX §5.6): tabela-resumo no topo + `termos_campanha_texto`
 * de `GET /v1/publico/configuracao` (funciona sem login — linkada do checkbox
 * do primeiro acesso e do rodapé de toda tela).
 */
export function Termos(): ReactNode {
  const { data, isLoading, error, refetch } = useConfiguracaoPublica();

  const texto = data ? valorConfig(data, 'termos_campanha_texto') : null;
  const brindeIndicado = data ? valorConfig(data, 'brinde_indicado_descricao') : null;
  const campanhaFim = data ? valorConfig(data, 'campanha_fim') : null;

  return (
    <PortalShell voltarPara="/">
      <h1 className="tipo-titulo text-tinta-forte">Termos da campanha</h1>

      {isLoading && <Esqueleto className="mt-4 h-64 rounded-2" />}

      {error && (
        <div className="mt-4">
          <FalhaRede aoTentarDeNovo={() => void refetch()} />
          {error instanceof ApiError && !error.ehRede && (
            <p className="mt-2 tipo-nota text-tinta-3">Tente novamente em instantes.</p>
          )}
        </div>
      )}

      {data && (
        <>
          <dl className="mt-5 divide-y divide-linha border-y border-linha">
            <ResumoLinha
              rotulo="Vale até"
              valor={campanhaFim ? dataLonga(campanhaFim) : '07/07/2027'}
            />
            <ResumoLinha
              rotulo="Limite de indicações"
              valor="sem limite — o ciclo de 4 brindes recomeça"
            />
            <ResumoLinha
              rotulo="Prazo para retirar o voucher"
              valor="não tem — vale até ser usado"
            />
            <ResumoLinha
              rotulo="Brinde de quem é indicado"
              valor={`${brindeIndicado ?? 'Cristalização do vidro'} (só para cliente novo)`}
            />
          </dl>

          {texto ? (
            <p className="mt-6 max-w-[56ch] whitespace-pre-wrap tipo-nota text-tinta">{texto}</p>
          ) : (
            <p className="mt-6 tipo-nota text-tinta-3">
              O texto completo dos termos ainda não foi publicado. Fale com a Varga para mais
              detalhes.
            </p>
          )}
        </>
      )}
    </PortalShell>
  );
}

function ResumoLinha({ rotulo, valor }: { rotulo: string; valor: string }): ReactNode {
  return (
    <div className="flex flex-col gap-0.5 py-3">
      <dt className="tipo-rotulo text-tinta-2">{rotulo}</dt>
      <dd className="tipo-corpo text-tinta-forte">{valor}</dd>
    </div>
  );
}
